import { trackEvent } from '@99designs/tracking';

export interface TrackShareClickOptions {
    share_subject_type: string;
    location: string;
}

export interface DownloadOptions {
    location: string;
    file_name: string;
    file_type: string;
}

// @see https://gitlab.com/vistaprint-org/99designs/analytics/blob/57f95fbdf12c9d5e781b7043885ee4c515f4ea5f/tracking-plan/common.yaml#L2
export function trackSocialShare(shareVia: string, options: TrackShareClickOptions) {
    trackEvent('Clicked Social Share Button', {
        share_via: shareVia,
        share_subject_type: options.share_subject_type,
        location: options.location,
    });
}

export function trackDownload(options: DownloadOptions) {
    trackEvent('File Downloaded', {
        location: options.location,
        file_name: options.file_name,
        file_type: options.file_type,
    });
}
